import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {PasswordValidation} from "../../core/validators/password-validation";
import {RegistroUsuariosService} from "./registro-usuarios.service";
import {HttpErrorResponse} from "@angular/common/http";
import {MessageService} from "primeng/components/common/messageservice";

@Component({
  selector: 'app-usuariosppap',
  templateUrl: './registro-usuarios.component.html',
  styleUrls: ['./registro-usuarios.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RegistroUsuariosComponent implements OnInit {
  private EMAIL_REGEXP = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  newUserForm: FormGroup;
  usuariosPPAP = [];
  domains = [];
  roles = [];
  selectedDomain = "";

  constructor(private formBuilder: FormBuilder,
              private usuariosppapService: RegistroUsuariosService,
              private messageService: MessageService) {
  }

  ngOnInit() {
    this.newUserForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      role: ['', [Validators.required]],
      firstName: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(20)]],
      middleName: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(40)]],
      lastName: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(40)]],
      birthday: ['', [Validators.required, legalAge()]],
      password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(15)]],
      passwordConfirm: ['', Validators.required],
    }, {
      validator: PasswordValidation.MatchFieldsFactory('password', 'passwordConfirm', 'matchField')
    });

    this.usuariosppapService.getTrustedDomains().subscribe((trustedDomains) => {
      this.domains = trustedDomains;
      this.selectedDomain = trustedDomains[0].domain;
    }, error => {
      this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error
        });
    });

    this.usuariosppapService.getRegisterRoles().subscribe((roles) => {
      this.roles = roles;
      this.newUserForm.patchValue({
        role: this.roles[0].role
      });
    }, error => {
      this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error
        });
    });

  }

  onSubmit() {
    const request = this.newUserForm.value;
    request.username = request.username + "@" + this.selectedDomain;
    this.usuariosppapService.registerPpapUser(request).subscribe((response) => {
      console.log("Registro completo");
      this.messageService.add({
        severity: 'success',
        summary: 'Registro completo',
        detail: 'Se ha enviado un correo a la cuenta: ' + response.username
      });
      this.newUserForm.reset();
      this.newUserForm.patchValue({
        role: this.roles[0].role
      });
    }, (error: HttpErrorResponse) => {
      console.log("Registro:registerPpapUser:error", error);
      if (error.status !== 200) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error de registro',
          detail: error.error.detail
        });
      }
    });
  }
}

export function legalAge(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } => {
    if (!control.value) {
      return null;
    } else {
      return ((new Date()).getFullYear() - control.value.getFullYear()) >= 18 ? null : {'legalAge': true};
    }
  };
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/usuariosppap/registro-usuarios.component.ts